import { Link } from "react-router-dom";
import HomeLess from "../../../assets/why-do-homeless.jpg";
import { useSelector } from "react-redux";
function ContentSection() {
  const committeeHomePage = useSelector(
    (x) => x?.committee?.getCommitteeHomePageIntegrationDataResponse?.data
  );
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;
  return (
    <section
      className="content-section bg-light-blue p-0"
      dangerouslySetInnerHTML={{
        __html: committeeHomePage?.committeeSectionThreeDescription,
      }}
    ></section>

    // <section class="content-section bg-light-blue p-0">
    //   <div class="row" data-sal="slide-up" data-sal-duration="900">
    //     <div class="col-lg-6">
    //       <div class="content-box">
    //         <h2 class="main-title">
    //           {committeeHomePage?.committeeSectionThreeTitle}
    //         </h2>

    //         <div class="text-container">
    //           <div class="text-preview">
    //             <p
    //               dangerouslySetInnerHTML={{
    //                 __html: committeeHomePage?.committeeSectionThreeDescription,
    //               }}
    //             ></p>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //     <div class="col-lg-6">
    //       <img
    //         src={ImageURL + committeeHomePage?.committeeSectionFourImage}
    //         alt="Results-based accountability"
    //         class="img-fluid cover-image"
    //       />
    //     </div>
    //   </div>
    // </section>
  );
}

export default ContentSection;
